/**
 * BillingCancel — V2 Premium Experience (V2.0 Phase 5, Cluster A).
 *
 * Route: `/billing/cancel`. Friendly bounce page when a Stripe Checkout is
 * abandoned. No card was charged; user account, data, and readiness score
 * remain intact.
 */
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import AuthShell from "./AuthShell";
import { V2Button } from "@/components/v2/FormPrimitives";

export default function BillingCancel() {
  const [params] = useSearchParams();
  const planId = params.get("plan_id");

  return (
    <AuthShell testId="billing-cancel-page" title="You haven't subscribed yet.">
      <div className="rounded-v2-2xl bg-v2-surface border border-v2-border shadow-v2-card p-6 md:p-8 text-center">
        <div className="w-14 h-14 rounded-v2-xl bg-v2-accentSoft mx-auto mb-4 flex items-center justify-center">
          <Info className="w-6 h-6 text-v2-accent" />
        </div>
        <p
          data-testid="billing-cancel-message"
          className="text-v2-body-md text-v2-textMuted mb-6 leading-relaxed"
        >
          No card was charged. Whenever you're ready, pick a plan and you'll be back where you
          left off — your account, your data, and your readiness score are all still here.
        </p>
        <div className="flex flex-col gap-3">
          <V2Button
            as={Link}
            to={planId ? `/pricing?highlight=${planId}` : "/pricing"}
            data-testid="billing-cancel-back-pricing"
            fullWidth
          >
            Back to pricing <ArrowRight className="w-3.5 h-3.5" />
          </V2Button>
          <Link
            data-testid="billing-cancel-dashboard"
            to="/dashboard"
            className="text-v2-body-sm text-v2-textMuted hover:text-v2-text transition-colors"
          >
            Go to dashboard
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
